// extracted by mini-css-extract-plugin
module.exports = {"EntryForm":"EntryForm__15Wv_","EinLabel":"EinLabel__a0AVj"};